export default {
  syncBoxes: {
    title: "Synchronise folders",
    advice: "Our advice is to at least synchronise the Inbox and Sent folders",
    toggleAll: "Toggle all folders on/off",
  },

  list: {
    noAccount: "You have not created any account yet"
  },

  accountTypes: {
    outlook: "Outlook",
    custom: "Other",
  },

  create: {
    title: "Create new imap account",
    type: {
      label: "Account type",
      placeholder: "Select an account type",
    },
    email: "Email address",
    password: "Password",
    host: {
      label: "Imap address",
      placeholder: "e.g. imap.your-domain.cp,",
    },
    port: {
      label: "Port",
      placeholder: '993',
    },
  },

  button: {
    save: "Create imap account",
    edit: "Save",
    cancel: "Cancel",
  },

  edit: {
    title: "Edit imap account"
  },

  api: {
    accountType: {
      notNull: "Select an account type",
    },
    username: {
      notNull: "Add your email address"
    },
    password: {
      notNull: "Add your password"
    },
    host: {
      notNull: "Add the servers imap address",
    },
    port: {
      notNull: "Add the port number",
    },
    error: {
      found: "Email account already exists",
    },
  },

  help: {
    title: "Email synchronisation",
    intro: "When choosing to synchronise your email accounts with Stickyweb, emails can automatically be displayed in the dossier widget. This happens based on the email addresses added to e.g. a company or contact",
    folders: {
      title: "Folders",
      text: "When adding an email account to Stickyweb, we will first scan the folder structure. You can then decide which folders you want to synchronise. This way, you keep control. Our advise is to at least synchronise the Inbox and Sent folders.",
    }
  },
}
